import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRefine({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 15.5A2.5 2.5 0 115.208 19H3a1 1 0 01-.117-1.993L3 17h2.208A2.5 2.5 0 017.5 15.5zM21 17a1 1 0 01.117 1.993L21 19h-8a1 1 0 01-.117-1.993L13 17h8zm-13.5.5a.5.5 0 100 1 .5.5 0 000-1zm7-8a2.5 2.5 0 11-2.292 3.5H3a1 1 0 01-.117-1.993L3 11h9.208A2.5 2.5 0 0114.5 9.5zM21 11a1 1 0 01.117 1.993L21 13h-1a1 1 0 01-.117-1.993L20 11h1zm-6.5.5a.5.5 0 100 1 .5.5 0 000-1zm-7-8A2.5 2.5 0 115.208 7H3a1 1 0 01-.117-1.993L3 5h2.208A2.5 2.5 0 017.5 3.5zM21 5a1 1 0 01.117 1.993L21 7h-8a1 1 0 01-.117-1.993L13 5h8zm-13.5.5a.5.5 0 100 1 .5.5 0 000-1z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRefine
